import { useState } from "react"
import { post } from "../../api/api"

export default function KeywordCluster() {
  const [keywords, setKeywords] = useState("")
  const [clusters, setClusters] = useState([])

  async function runCluster() {
    const res = await post("/cluster", {
      keywords: keywords.split("\n").map((item) => item.trim()).filter(Boolean)
    })

    setClusters(res.data.clusters || [])
  }

  return (
    <div className="page">
      <h1>Keyword Clustering</h1>
      <div className="card">
        <textarea
          placeholder="Enter keywords, one per line"
          value={keywords}
          onChange={(e) => setKeywords(e.target.value)}
        />
        <button onClick={runCluster}>Run clustering</button>
      </div>
      <div className="grid">
        {clusters.map((cluster) => (
          <div className="card" key={cluster.topic}>
            <h3>{cluster.topic}</h3>
            <p className="muted">{cluster.keywords.join(", ")}</p>
          </div>
        ))}
      </div>
    </div>
  )
}
